export default __webpack_public_path__ + "assets/bf50daa4a9a90e2470edf444e156584a.svg";